import { TRACK_ASSET_QUESTION_CLICKED_EVENT, TRACK_ASSET_SUMMARISE_CLICKED_EVENT, TRACK_DRAFT_AN_EMAIL_CLICKED_EVENT, TRACK_NEW_CHAT_CLICKED_EVENT, TRACK_SEARCH_REACTED_EVENT, TRACK_SEEK_SESSIONS_CLICKED_EVENT, TRACK_SEEK_SESSIONS_DELETED_EVENT, TRACK_SEEK_VIEW_CLICKED_EVENT, TRACK_SEEK_HISTORY_DELETED_EVENT, TRACK_SEEK_PROMPT_CLICKED_EVENT } from "src/constants/adoption/eventTypes";
import { trackEventForAdoption } from "../adoption";
import { useDispatch } from "react-redux";
import { ISeekProps, ISeekDraftEmail, ISeekResponseReacted, SeekPromptClicked } from "src/types/adoption/seek";

export const useSeekAdoption = () => {

  const dispatch = useDispatch();


  const dispatchEvent = (data: any) => {
    dispatch(trackEventForAdoption(data));
  }


  const trackSeekNewChatClicked = (sourceCta: string) => {

    let properties = {
      source_cta: sourceCta
    }


    const data = {
      event: TRACK_NEW_CHAT_CLICKED_EVENT,
      properties: properties
    }
    dispatchEvent(data);

  }

  const trackSeekResponseReactedEvent = ({ reactionType, sourceCta }: ISeekResponseReacted) => {

    let properties = {
      reaction_type: reactionType,
      source_cta: sourceCta
    }

    let data = {
      event: TRACK_SEARCH_REACTED_EVENT,
      properties: properties
    }

    dispatchEvent(data);

  }

  const trackSeekSessionsClicked = () => {

    const data = {
      event: TRACK_SEEK_SESSIONS_CLICKED_EVENT,
      properties: {}
    }
    dispatchEvent(data);

  }

  const trackSeekDraftAnEmailClickedEvent = ({ assetTypes, sourceCta }: ISeekDraftEmail) => {

    let properties = {
      asset_type: assetTypes,
      source_cta: sourceCta
    }

    let data = {
      event: TRACK_DRAFT_AN_EMAIL_CLICKED_EVENT,
      properties: properties
    }

    dispatchEvent(data);
  }

  const trackSeekAssetSummariseClickedEvent = ({ assetType, sourceCta }: ISeekProps) => {

    let data = {
      event: TRACK_ASSET_SUMMARISE_CLICKED_EVENT,
      properties: {
        asset_type: assetType,
        source_cta: sourceCta
      }
    }

    dispatchEvent(data);

  }

  const trackAssetPromptsClickedEvent = ({ assetType, sourceCta }: ISeekProps) => {

    let data = {
      event: TRACK_ASSET_QUESTION_CLICKED_EVENT,
      properties: {
        asset_type: assetType,
        source_cta: sourceCta
      }
    }

    dispatchEvent(data);

  }

  const trackSeekClicked = ({ assetType, sourceCta }: ISeekProps) => {


    let properties = {
      asset_type: assetType,
      source_cta: sourceCta
    }

    const event = {
      event: TRACK_SEEK_VIEW_CLICKED_EVENT,
      properties: properties,
    }

    dispatch(trackEventForAdoption(event));
  }

  const trackSeekHistoryDeleted = () => {
    
    const event = {
      event: TRACK_SEEK_HISTORY_DELETED_EVENT,
      properties: {}
    }

    dispatch(trackEventForAdoption(event));
  }

  const trackSeekPromptClicked = ({ prompt }: SeekPromptClicked) => {

    const event = {
      event: TRACK_SEEK_PROMPT_CLICKED_EVENT,
      properties: {
        prompt: prompt
      }
    }

    dispatch(trackEventForAdoption(event));
  }


  return {
    trackSeekNewChatClicked,
    trackSeekResponseReactedEvent,
    trackSeekSessionsClicked,
    trackSeekDraftAnEmailClickedEvent,
    trackSeekAssetSummariseClickedEvent,
    trackAssetPromptsClickedEvent,
    trackSeekClicked,
    trackSeekHistoryDeleted,
    trackSeekPromptClicked
  };

}